export default __webpack_public_path__ + "a98b43d7f52d30fbdbfe1a3d39dd48a4.png";